export function limiteAbastecimentosInRequest(params = {}) {
  return {
    type: '@limiteabastecimento/LIMITEABASTECIMENTO_IN_REQUEST',
    payload: { params },
  };
}

export function findLimiteAbastecimento(id) {
  return {
    type: '@limiteabastecimento/FIND_LIMITEABASTECIMENTO',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@limiteabastecimento/FAILED_REQUEST',
  };
}

export function deleteLimiteAbastecimento(idLimiteAbastecimento, params) {
  return {
    type: '@limiteabastecimento/DELETE_LIMITEABASTECIMENTO',
    payload: { idLimiteAbastecimento, params },
  };
}

export function updateLimiteAbastecimento(limiteAbastecimento, params) {
  return {
    type: '@limiteabastecimento/UPDATE_LIMITEABASTECIMENTO',
    payload: { limiteAbastecimento, params },
  };
}

export function storeLimiteAbastecimento(limiteabastecimento, params) {
  return {
    type: '@limiteabastecimento/STORE_LIMITEABASTECIMENTO',
    payload: { limiteabastecimento, params },
  };
}

export function successInRequest(
  limiteabastecimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@limiteabastecimento/SUCCESS_IN_REQUEST',
    payload: { limiteabastecimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(limiteabastecimento) {
  return {
    type: '@limiteabastecimento/SUCCESS_REQUEST',
    payload: { limiteabastecimento },
  };
}

export function successRemove(params) {
  return {
    type: '@limiteabastecimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@limiteabastecimento/RECORD_FILTERING',
    payload: { params },
  };
}
